import type { AssetSource } from "../assetTypes.ts";
import { useAssetUrl } from "./useAssetUrl.ts";

export const useAssetSourceUrl = (assetSource: AssetSource | undefined): string | undefined =>
  useAssetUrl(assetSource && "assetId" in assetSource ? assetSource.assetId : undefined) ??
  (assetSource && "url" in assetSource ? assetSource.url : undefined);
